export const multiselect = {
  multiselect: {
    chip: {
      borderRadius: 'var(--p-border-radius-xl)',
    },
  },
};
